module.exports = __webpack_public_path__ + "img/notice-bvic-zh.cbe05c3a.jpeg";